import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import androidOne from "./assets/android/android_1.png";
import androidThree from "./assets/android/android_3.png";
import androidFour from "./assets/android/android_4.png";
import androidFive from "./assets/android/android_5.png";
import androidSix from "./assets/android/android_6.png";
import androidSeven from "./assets/android/android_7.png";
import androidEight from "./assets/android/android_8.png";
import androidNine from "./assets/android/android_9.png";
import androidTen from "./assets/android/android_10.png";

import webDevSeven from "./assets/web-dev/web_dev_7.png";
import portalNine from "./assets/portal/portal_8.png";

import { Divider } from "@mui/material";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const AndroidDevelopment = () => {
  const scrollRef = useRef();

  const images = [
    androidThree,
    androidFour,
    androidFive,
    androidSix,
    androidSeven,
    androidEight,
  ];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${androidOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Andorid Development
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              Andorid Development
            </Typography>
            <Typography variant="body1" paragraph>
              Native Android Development involves building mobile applications
              specifically for Android using tools and languages officially
              supported by Google, such as Kotlin and Java. This approach
              provides direct access to all Android device features, ensuring
              high performance, seamless user experience, and full compatibility
              across various Android devices. Native apps are more responsive,
              faster, and optimized for UI/UX standards, making them ideal for
              businesses aiming for superior functionality and user engagement.
            </Typography>

            <Typography variant="body1" paragraph>
              With native Android development, we can create robust, secure, and
              scalable applications tailored to your unique requirements.
              Whether it’s integrating device hardware like GPS, camera, or
              sensors, or building complex real-time features, native
              development offers unmatched flexibility and performance. It also
              allows better control over animations, transitions, and
              interactions, delivering a polished and intuitive user experience.
              Our team leverages the latest Android SDKs, APIs, and design
              patterns to bring your vision to life with precision and
              efficiency.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why us?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              When it comes to Android development, we bring unmatched expertise
              and dedication to the table. Our team has hands-on experience in
              building high-performance, scalable, and visually engaging native
              Android applications using the latest technologies like Kotlin and
              Java. We follow best practices in UI/UX design, code architecture,
              and performance optimization to ensure that your app not only
              functions flawlessly but also delights users. What sets us apart
              is our deep understanding of the Android ecosystem and our ability
              to align your business goals with powerful mobile solutions. From
              idea validation and design to development, testing, and launch, we
              provide end-to-end support. Whether you're building a consumer
              app, an enterprise solution, or a feature-rich e-commerce
              platform, we are your trusted partners in delivering Android apps
              that are secure, user-friendly, and built for success.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={portalNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Years of experience
            </Typography>
            <Typography variant="body1">
              With several years of industry experience, our team has built a
              solid reputation for delivering high-quality Android applications
              tailored to meet diverse business needs. We have successfully
              worked on projects across various domains including e-commerce,
              healthcare, logistics, and education—helping clients turn their
              ideas into robust, scalable mobile solutions. Our deep-rooted
              expertise allows us to anticipate challenges, follow best
              practices, and leverage the latest Android tools and frameworks to
              ensure seamless performance. From startups to established
              enterprises, we've partnered with businesses of all sizes to
              create impactful applications that are not only technically sound
              but also deliver real value to end users.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Latest tools and technologies
            </Typography>
            <Typography variant="body1">
              We leverage the most advanced tools and technologies to ensure
              your Android applications are future-ready, efficient, and
              scalable. Our development stack includes Kotlin and Java for
              native Android development, ensuring optimal performance and
              compatibility with the latest Android versions. We also integrate
              Jetpack libraries, Android Studio, and Firebase for rapid
              development, enhanced UI/UX, real-time analytics, and secure
              backend support. Our team stays up to date with the evolving
              Android ecosystem, adopting modern design patterns like MVVM,
              using Room for local databases, and applying CI/CD pipelines for
              faster and reliable deployments. This commitment to modern tools
              enables us to build apps that are not only robust but also aligned
              with the latest market expectations and user behavior trends.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={androidNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={androidTen}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Affordable Android Application development
            </Typography>
            <Typography variant="body1">
              We understand that budget is a major factor when launching a
              mobile application. That’s why we offer affordable Android app
              development services without compromising on quality. Our goal is
              to deliver high-performance, scalable, and secure native Android
              applications that fit well within your budget. Whether you're a
              startup or an established business, we tailor our development
              approach to meet your financial goals while ensuring a top-tier
              user experience. With a streamlined development process and access
              to a skilled in-house team, we eliminate unnecessary costs and
              delays. From concept to deployment, we work efficiently to build
              applications that deliver value and functionality—at a cost that
              makes sense for your business. Get in touch with us to discuss a
              cost-effective solution that meets your vision.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Extended Support
            </Typography>
            <Typography variant="body1">
              We believe our job doesn’t end once your Android application is
              deployed. That’s why we offer comprehensive extended support to
              ensure your app continues to perform at its best. From resolving
              bugs and handling updates to managing compatibility with the
              latest Android versions, we stand by your side throughout the
              app’s lifecycle. Our dedicated support team is always available to
              address your concerns, implement improvements, and help your
              application evolve based on user feedback and market trends. With
              us, you get more than a development partner—you get a long-term
              technology ally committed to your app’s success.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={webDevSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default AndroidDevelopment;
